import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import LogoMark from "./LogoMark";

const links = [
  { to:"/",              label:"Home" },
  { to:"/our-why",       label:"Our Why" },
  { to:"/services",      label:"Services" },
  { to:"/team",          label:"Meet the Team" },
  { to:"/clients",       label:"Clients" },
  { to:"/testimonials",  label:"Testimonials" },
  { to:"/podcast",       label:"Podcast" },
  { to:"/health-archive",label:"Health Archive" },
  { to:"/contact",       label:"Contact" },
];

export default function Navbar() {
  const [scrolled,  setScrolled]  = useState(false);
  const [menuOpen,  setMenuOpen]  = useState(false);
  const { pathname } = useLocation();

  useEffect(()=>{
    const fn = ()=>setScrolled(window.scrollY>50);
    window.addEventListener("scroll",fn);
    return ()=>window.removeEventListener("scroll",fn);
  },[]);
  useEffect(()=>setMenuOpen(false),[pathname]);

  return (
    <>
      <nav style={{
        position:"fixed",top:0,left:0,right:0,zIndex:200,
        padding:"0.9rem 2rem",display:"flex",alignItems:"center",justifyContent:"space-between",
        background: scrolled?"rgba(11,11,11,0.97)":"rgba(11,11,11,0.85)",
        backdropFilter:"blur(16px)",
        borderBottom: scrolled?"1px solid rgba(255,255,255,0.07)":"none",
        transition:"all 0.3s",
      }}>
        <Link to="/" style={{ display:"flex",alignItems:"center",gap:"0.5rem" }}>
          <LogoMark size={38} showBackground={true} />
          <span style={{ fontFamily:"var(--font)",fontWeight:800,fontSize:"1.05rem",color:"#fff",letterSpacing:"-0.01em" }}>The Health Plug</span>
        </Link>

        {/* Desktop */}
        <div style={{ display:"flex",alignItems:"center",gap:"1.25rem", flexWrap:"nowrap" }} className="hide-mobile">
          {links.map(l=>(
            <Link key={l.to} to={l.to} style={{
              color: pathname===l.to?"#95BB83":"rgba(255,255,255,0.6)",
              fontSize:"0.78rem",fontFamily:"var(--font)",fontWeight:500,
              letterSpacing:"0.02em",transition:"color 0.2s",whiteSpace:"nowrap",
            }}
              onMouseEnter={e=>e.target.style.color="#fff"}
              onMouseLeave={e=>e.target.style.color=pathname===l.to?"#95BB83":"rgba(255,255,255,0.6)"}
            >{l.label}</Link>
          ))}
          <Link to="/contact" className="btn-red" style={{ padding:"0.5rem 1.1rem",fontSize:"0.78rem",whiteSpace:"nowrap" }}>Plan a Campaign</Link>
        </div>

        {/* Hamburger */}
        <button onClick={()=>setMenuOpen(o=>!o)} style={{ background:"none",border:"none",color:"#fff",fontSize:"1.4rem",cursor:"pointer",display:"none" }} className="mobile-menu-btn">
          {menuOpen?"✕":"☰"}
        </button>
      </nav>

      {menuOpen && (
        <div style={{ position:"fixed",inset:0,zIndex:199,background:"#0B0B0B",paddingTop:"5rem",padding:"5rem 2rem 2rem",display:"flex",flexDirection:"column",gap:"0.25rem",overflowY:"auto" }}>
          {links.map(l=>(
            <Link key={l.to} to={l.to} style={{ color:"#fff",fontSize:"1.3rem",fontFamily:"var(--font)",fontWeight:700,padding:"0.75rem 0",borderBottom:"1px solid rgba(255,255,255,0.07)" }}>{l.label}</Link>
          ))}
          <Link to="/contact" className="btn-red" style={{ marginTop:"1.5rem",textAlign:"center",padding:"1rem" }}>Plan a Health Campaign</Link>
        </div>
      )}

      <style>{`.mobile-menu-btn{display:none!important}@media(max-width:900px){.mobile-menu-btn{display:flex!important}.hide-mobile{display:none!important}}`}</style>
    </>
  );
}
